<template>
  <span class="priority-tag">
    <span :class="tagClass" :title="tag">{{ tag }}</span>
  </span>
</template>

<script>

export default {
  props: {
    value: [String, Number]
  },

  created() {
    this.value = this.params && this.params.data && this.params.data.Until
  },

  computed: {
    tag() {
      if (this.params.data.IsImmediatePayment) {
        return 'Immediate'
      } else {
        let diff = this.getTimeDifference(this.params.data.TimeDue)
        let res = ''
        if (diff < 0) {
          diff = Math.abs(diff)
          res = 'Overdue - '
        }

        let hours = Math.floor(diff / 36e5)
        let minutes = Math.floor(diff % 36e5 / 60000)
        let hStr = hours === 0 ? '' : hours + ' hr'
        let mStr = minutes === 0 ? '' : minutes + ' min'
        res += hStr + (hStr !== '' ? ' ' : '') + mStr

        return res
      }
    },
    tagClass() {
      return 'text ' + this.getTimeDue(this.params)
    }
  },

  methods: {
    getTimeDifference(timeDue) {
      let now = new Date().getTime()
      let due = new Date(this.getDateFromAspNetFormat(timeDue)).getTime()
      return due - now
    },

    getTimeDue(params) {
      if (params.data.IsImmediatePayment) {
        return 'badge overdue'
      }
      if (this.getTimeDifference(params.data.TimeDue) < 0) {
        return 'text-danger'
      }

      return ''
    },

    getDateFromAspNetFormat(date) {
      const re = /-?\d+/
      const m = re.exec(date)
      return parseInt(m[0], 10)
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/components/_modules/Invoices/statuses.scss";

</style>



// WEBPACK FOOTER //
// src/components/_modules/InvoiceScan/CellComp/TimeDueComp.vue